export default __webpack_public_path__ + "static/media/case_study_renault_cover.03763aee.jpg";